import {
  StepComponentTypes,
  SWTypes
} from "../../interfaces/sw/SWInterfaces";

const swSupportedInputComponents: Map<SWTypes, StepComponentTypes[]> = new Map();
swSupportedInputComponents.set(SWTypes.ECL, [
]);
swSupportedInputComponents.set(SWTypes.CL, [
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.DateTimeInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.YesNoInput,
]);
swSupportedInputComponents.set(SWTypes.LCL, [
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.DateTimeInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.YesNoInput,
]);
swSupportedInputComponents.set(SWTypes.SWI, [
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.YesNoInput,
]);
swSupportedInputComponents.set(SWTypes.TLMSWI, [
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.YesNoInput,
  StepComponentTypes.VideoInput,
  StepComponentTypes.AudioInput,
  StepComponentTypes.FormulaNumerical,
  StepComponentTypes.PassFailInput,
]);
swSupportedInputComponents.set(SWTypes.TLMRC, [
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.YesNoInput,
  StepComponentTypes.VideoInput,
  StepComponentTypes.AudioInput,
  StepComponentTypes.PassFailInput,
]);
swSupportedInputComponents.set(SWTypes.MFGSWI, [
  StepComponentTypes.YesNoInput,
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.PassFailInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.VideoInput,
]);
swSupportedInputComponents.set(SWTypes.MFGCL, [
  StepComponentTypes.YesNoInput,
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.PassFailInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.VideoInput,
]);
swSupportedInputComponents.set(SWTypes.MFGRC, [
  StepComponentTypes.YesNoInput,
  StepComponentTypes.NumberInput,
  StepComponentTypes.TextInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.PassFailInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.VideoInput,
]);

const allInputTypes =
  [StepComponentTypes.NumberInput,
  StepComponentTypes.SelectInput,
  StepComponentTypes.MultiSelectInput,
  StepComponentTypes.DateInput,
  StepComponentTypes.DateTimeInput,
  StepComponentTypes.PhotoInput,
  StepComponentTypes.SignatureInput,
  StepComponentTypes.YesNoInput,
  StepComponentTypes.VideoInput,
  StepComponentTypes.AudioInput,
  StepComponentTypes.FormulaNumerical,
  StepComponentTypes.PassFailInput]

const isInputComponent = (componentType: StepComponentTypes) => {
  return allInputTypes.includes(componentType);
}

export default swSupportedInputComponents;
export { isInputComponent };